import {useIsComingFromInitialFlowStore} from 'presentation/pages/others/selection-flow/store/useIsComingFromInitialFlowStore';
import {BookingTypeEnum} from '../../constants';
import {useOpenBookingConfirmationDrawerStore} from '../../store/useOpenBookingConfirmationDrawerStore';
import {useSelectedServiceTypeStore} from '../../store/useSelectedServiceTypeStore';
import {useBookingPlanChangeStore} from '../../store/useBookingPlanChangeStore';
import {useCallback} from 'react';
import {SelectionFlowEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';

function useBookingConfirmationDrawer() {
	const navigate = useNavigate();

	const bookingConfirmationDrawerIsOpened = useOpenBookingConfirmationDrawerStore(
		state => state.openBookingConfirmationDrawer,
	);

	const setOpenBookingConfirmationDrawer = useOpenBookingConfirmationDrawerStore(
		state => state.setOpenBookingConfirmationDrawer,
	);

	const handleOpenBookingConfirmationDrawer = () => {
		setOpenBookingConfirmationDrawer(true);
	};

	const handleCloseBookingConfirmationDrawer = () => {
		setOpenBookingConfirmationDrawer(false);
	};

	const selectedServiceType = useSelectedServiceTypeStore(state => state.selectedServiceType);

	const setSelectedServiceType = useSelectedServiceTypeStore(
		state => state.setSelectedServiceType,
	);

	const setIsComingFromBookingFlow = useBookingPlanChangeStore(
		state => state.setIsComingFromBookingFlow,
	);

	const setIsComingFromInitialFlow = useIsComingFromInitialFlowStore(
		currentState => currentState.setIsComingFromInitialFlow,
	);

	const handleChangeBeneficiaryWithoutPathFrom = useCallback(() => {
		if (selectedServiceType === BookingTypeEnum.ODONTO) setIsComingFromInitialFlow(true);
		navigate(SelectionFlowEnum.BENEFICIARY_SELECTION);
	}, [selectedServiceType]);

	const handleChangeBeneficiary = () => {
		setIsComingFromBookingFlow(true);

		handleCloseBookingConfirmationDrawer();
		handleChangeBeneficiaryWithoutPathFrom();
	};

	return {
		bookingConfirmationDrawerIsOpened,
		handleOpenBookingConfirmationDrawer,
		handleCloseBookingConfirmationDrawer,
		selectedServiceType,
		setSelectedServiceType,
		handleChangeBeneficiary,
	};
}

export {useBookingConfirmationDrawer};
